module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"records","outOf":"{0} - {1} out of {2} {3}","perPage":"{0} per page"}}')
  delete Component.options._Ctor
}
